module.exports = __webpack_public_path__ + "static/media/Pelican.f5a11e5d.png";